import { render, staticRenderFns } from "./BaseSheetField.vue?vue&type=template&id=47b9ff50&"
import script from "./BaseSheetField.vue?vue&type=script&lang=ts&"
export * from "./BaseSheetField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports